module.exports = __webpack_public_path__ + "img/card-bg-2.fb12150.png";